<template>
  <div id="content" class="dlnkmediatheque_games container-fluid">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <div class="mb-7"><h1 class="display-4 text-white mb-4">Ludothèque</h1></div>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
        </svg>
      </figure>
    </div>


    <div class="row">

      <div class="col-lg-3">
        <form>

          <div class="border-bottom pb-4 mb-4">
            <h4>Genres</h4>

            <div
                class="form-group d-flex align-items-center justify-content-between font-size-1 text-lh-lg text-body mb-1"
                v-for="genre in genres"
                :key="genre.id"
            >
              <div class="custom-control custom-checkbox">
                <input type="checkbox" v-model="checked_genres" :value="genre.id" v-on:change="sort_by_type(genre.id)"
                       class="custom-control-input" :id="'genre_' + genre.id">
                <label class="custom-control-label text-lh-lg" :for="'genre_' + genre.id">{{ genre.name }}</label>
              </div>
              <small>{{ genre.count }}</small>
            </div>
          </div>

        </form>
      </div>

      <div class="col-lg-9">

        <!-- search bar-->
        <form class="input-group input-group-merge mt-4">
          <input type="search" class="form-control form-control-sm" placeholder="Chercher un livre"
                 aria-label="Chercher un jeu" aria-describedby="search-game" v-model="query">
          <div class="input-group-append">
            <span class="input-group-text" id="search-game">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </form>
        <small v-if="search_message.length > 5" class="form-text text-muted d-block">{{ search_message }}</small>
        <!-- END search bar-->

        <!-- Pagination -->
        <div class="mt-2">
          <dlnkpagination
              :page="page"
              :page_count="page_count"
              @next_page="next_page()"
              @prev_page="prev_page()"
              @set_page="set_page($event)">
          </dlnkpagination>
        </div>
        <!-- End Pagination -->

        <!-- Games -->
        <div class="row mx-n2 mb-5">

          <div class="col-sm-6 col-lg-3 px-2 px-sm-3 mb-3 mb-sm-5"
               v-for="game in games" :key="game.id">
            <!-- Product -->
            <div class="card card-bordered shadow-none text-center h-100">
              <a :href="'/module/dlnkmediatheque/game?game_id=' + game.id" class="position-relative">
                <img class="card-img-top" :src="game.picture"
                     alt="Visuel du livre">

                <div class="position-absolute top-0 left-0 pt-3 pl-3">
                  <span v-if="parseInt(game.loaned)" class="badge badge-danger badge-pill">En prêt</span>
                  <span v-else-if="parseInt(game.reserved)" class="badge badge-warning badge-pill">Réservé</span>
                  <span v-else class="badge badge-success badge-pill">Disponible</span>
                </div>
                <div v-if="admin" class="position-absolute top-0 right-0 pt-3 pr-3">
                  <a :href="'/module/dlnkmediatheque/edit_game?game_id=' + game.id"
                     class="btn btn-xs btn-icon btn-outline-info rounded-circle"
                     data-toggle="tooltip" data-placement="top" title="Modifier le livre">
                    <i class="fas fa-edit"></i>
                  </a>
                </div>

              </a>

              <div class="card-body pt-4 px-4 pb-0">
                <div class="mb-2">
                  <span class="d-block font-size-1">
                      <a :href="'/module/dlnkmediatheque/game?game_id=' + game.id" class="text-inherit">
                        {{ game.title }}
                      </a>
                  </span>

                </div>
              </div>

              <div class="card-footer border-0 pt-0 pb-4 px-4">
                <div class="d-block mt-1">
                  <span class="text-dark font-weight-bold">{{ game.place.name }}</span>
                </div>

                <div v-if="game.reservation_id" class="alert alert-info mt-2 w-100">
                  Vous avez reservé ce livre
                  <button type="button" class="btn btn-danger btn-sm" @click="delete_reservation(game.reservation_id)">
                    Annuler ma réservation
                  </button>
                </div>
                <div v-else-if="game.loaned_id" class="alert alert-success mt-2 w-100">
                  Vous devez rendre ce livre le {{ game.due_date }}
                </div>
                <button v-else type="button" class="btn btn-block btn-primary btn-pill transition-3d-hover"
                        @click="book_game(game.id)">
                  <span v-if="game.available">Reserver</span>
                  <span v-else>Pré-reserver</span>
                </button>
              </div>
            </div>
            <!-- End Product -->
          </div>

        </div>
        <!-- End Games -->

        <!-- Pagination -->
        <dlnkpagination
            :page="page"
            :page_count="page_count"
            @next_page="next_page()"
            @prev_page="prev_page()"
            @set_page="set_page($event)">
        </dlnkpagination>
        <!-- End Pagination -->

        <!-- Divider -->
        <div class="d-lg-none">
          <hr class="my-7 my-sm-11">
        </div>
        <!-- End Divider -->
      </div>


    </div>


    <a href="#" title="admin e-bibliotheque" class="btn btn-primary mb-4">
      Retour à la bibliothèque
    </a>

  </div>


</template>

<script>

export default {

  props: [],

  data: function () {
    return {
      admin: Boolean,
      page: 1,
      genre_id: Number,

      checked_genres: Array(),

      wait_data: true,

      games: Array(),
      page_count: Number,

      categories: Array(),
      genres: Array(),
      editors: Array(),
      query: "",
      search_message: String,

      message: "",
      message_type: "",
    }
  },

  mounted() {
    this.admin = true
    this.search_message = ""
    this.genre_id = 0
    //this.checked_genres = [0]
    this.get_data()
  },

  watch: {
    page: function (new_val, old_val) {

      if (new_val < 1) {
        this.page = 1
      }

      if (new_val > this.page_count) {
        this.page = this.page_count
      }

      this.get_data()
    },

    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.search_message = ""
        this.get_data();
      } else if (new_val.length > 0 && new_val.length > old_val.length) {
        this.search_message = "Veuillez taper au moins 3 caractères pour démarrer la recherche"
      } else {
        this.get_data()
      }
    }

  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    set_page: function (page) {
      page = parseInt(page)
      this.page = page
    },

    next_page: function () {
      this.page++
    },

    prev_page: function () {
      this.page--
    },

    book_game: async function (game_id) {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_games/" + game_id + "/mediatheque_game_reservations.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.post(api_url)
          .then(function (response) {
            _this.message = "Votre réservation est enregistrée"
            _this.message_type = "alert-success"
            _this.get_games()
          })
          .catch(function (error) {
            _this.message = error.response.data.base[0]
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },

    delete_reservation(reservation_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/my_mediatheque.php?reservation_id=' + parseInt(reservation_id);

      axios.delete(url)
          .then(function (response) {
            const status = response.data.status;

            if (status) {
              _this.message = "Réservation supprimé"
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = "Erreur"
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.message = "Erreur"
            _this.message_type = "alert-danger"
          })
          .then(function () {
            // always executed
          });
    },

    sort_by_type: function (id) {
      this.get_data()
    },

    get_games: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_games.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id
      api_url += '&page=' + _this.page

      axios.get(api_url)
          .then(function (response) {
            _this.games = response.data.games
            _this.page = response.data.meta.page
            _this.page_count = response.data.meta.pages
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_genres: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_game_genres.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.genres = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_editors: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_game_editors.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.editors = response.data
            _this.wait_data = false
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_data: function () {
      this.get_genres()
      this.get_editors()
      this.get_games()
    },

  }
}

</script>
